import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const StartDashing: React.FunctionComponent = () => (
  <Svg
    width={282}
    height={242}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M47.805 240.977c-16.9-10.4-36.2-31.6-44.8-61.1-8.9-30.8 2.2-50.3 30.2-53.1 28-2.8 21-20.4 19.2-35.6-1.8-15.2-10.4-33.4 2.6-52.3 15.7-22.9 72.1-46.5 103-4.4 20.8 28.4 19.9 58.2 48.6 48.3 19.5-6.7 61.1 3.1 71.3 41.2 19.6 73.3-44.9 117.5-44.9 117.5s-159.2.4-185.2-.5z"
      fill="#E5F3F7"
    />
    <path
      d="M251.105 101.477s-11.3 7-14.3 9.1c-3 2.1-6.8 4.2-7 5.3-.2 1.1.3 4.5.3 4.5l2.3.2-.3-4.2 22.9-14.1-3.9-.8z"
      fill="#C7C6B7"
    />
    <path
      d="M271.605 84.577c1.3 1.7 1.3 5.9.4 8.5-1 3.1-4.7 6.2-6.4 7.3-1.8 1.1-3.6 2.1-6.1 2.5-3.1.6-5.4.2-6.9-.5 0 0 3.5.1 6.1-.8 2.6-.9 6.3-3 7.8-4.5 1.6-1.5 4.4-5 5-7 .6-2.1.1-5.5.1-5.5zM137.005 121.577c1 0 19.6 5.2 20.2 6 .7.8.2 3.2.2 3.2l2-.2s.5-3.2-.2-4.3c-.7-1.2-17.5-5.8-18.8-6.3-1.3-.5-2-2.2-2-2.2l-1.4 3.8z"
      fill="#C7C6B7"
    />
    <path
      d="M155.705 133.877s-.2-1.8.3-2.6 2-1.1 3.5-.7c1.5.3 1.8 3.2 1.8 3.2l-5.6.1z"
      fill="#28362C"
    />
    <path
      d="M160.405 189.377s4-18.4 10.6-23.1c6.9-4.9 24.8-10.6 37.2-10.2 12.4.4 22.6 2.2 26.6 12.9s11.1 35.5 13.3 45.2c2.2 9.8.4 27.5.4 27.5l-86.2-.3c.1 0-4.1-41.8-1.9-52z"
      fill="#FBF476"
    />
    <path
      d="M227.505 123.677s.5-2.8 2.7-3.3 3.5.5 4.3 2.5c.6 2-7 .8-7 .8z"
      fill="#28362C"
    />
    <path
      d="M238.005 139.777c-1.2.9-8.8 2.1-16.5 4.9-4.8 1.8-9.6 3.1-11.1 5.1-2.7 3.5.1 10.4.1 10.4s-11.5 2.2-16.8 3.1c-5.3.9-12.9.9-12.9.9s.9-9.3-2.2-12c-1.5-1.3-9.5-2-16.2-1.2-7 .8-12.5 1.7-13.9.9-1.3-.8-3.2-14.3-1.4-16.5 1.8-2.2 24.8-3.5 27-4.4 2.2-.9 8.4-9.5 21.5-10.8 11-1 15.7 5.2 17.1 5.4 1.3.2 18.6-4 21.7-2.7 3.1 1.3 6.1 7.1 5.9 10.2-.2 3.1-1.1 5.8-2.3 6.7z"
      fill="#FBF476"
    />
    <path
      d="M232.305 126.677c-.6.5-2.4 3.4-.6 6.8 1.8 3.4 3.5 3.8 5.1 3.2.8-.3 2-3.1 1.6-5.7-.6-3.1-3.7-6.2-6.1-4.3z"
      fill="#E2E1DA"
    />
    <path
      d="M261.005 136.477s.5 1 2.1.9c1-.1 1.9-1.1 1.4-2.2s-1.2-1.7-2.2-1.7c-1 0-23.7-.6-25.1-.1-.8.3-.7 2.9.1 3.1 1.8.5 23.7 0 23.7 0z"
      fill="#C7C6B7"
    />
    <path
      d="M235.205 127.677c-.4.9-.4 3.8.2 5 .6 1.2 1.9 1.7 1.9 1.7s16.6-3.1 17.7-3.9c1.1-.8 2.4-2.4 1.8-4.7-.7-2.2-2-2.8-2.8-2.8-.8 0-18.1 3.2-18.8 4.7zM118.905 110.377c.3-.4 1.9-2.9 4.7-4.3 2.8-1.3 5.1-2.1 8.1-1.3 2.8.8 5.7 2.7 6.6 5 .9 2.3.8 7.1.2 8.6-.6 1.5-1.4 3.9-4.7 6-3.3 2.1-8.9 2.5-11 1.8-2.1-.7-5.8-3.8-6.3-7.4-.6-4.9 2.4-8.4 2.4-8.4z"
      fill="#28362C"
    />
    <path
      d="M131.305 106.177c2.7.4 6 2.3 6.3 6 .3 4-1.4 9.3-4.8 11.1-3.4 1.8-8 2.3-10.8 1-3-1.5-5.3-6.9-3.4-10.7 1.9-3.8 3.9-6.1 7.4-7 3.5-.9 5.3-.4 5.3-.4zM261.305 81.077c-4.7 1.5-8.2 4.6-10.2 7.3-2.3 2.9-2.6 8.5-1.6 9.8 1.4 1.9 3.8 2.5 7.3 1.7 4.4-1.1 8.6-4.9 10.7-7.3 3.3-3.8 3.1-8 2.1-9.5-2-3-6.7-2.5-8.3-2z"
      fill="#D7ECF2"
    />
    <path
      d="M171.005 228.877c-.1-6.7-1-18.601.7-23.701 1-3.1 10.3-9.5 16-12.9 5.7-3.3 14.2-4 23.5-1.3s20.5 10.2 21.6 12.1c1.2 2 1 5.8 1.1 11.6.2 8 .2 13.6 0 18.3"
      stroke="#F5E202"
      strokeWidth=".5"
      strokeMiterlimit="10"
    />
    <path
      d="M180.805 164.077s7.5 0 12.9-.9c5.3-.9 16.8-3.1 16.8-3.1s-.7-1.8-1.1-3.9c-.4 0-.8 0-1.2-.1-8.3-.3-19.1 2.2-27.4 5.3.1 1.6 0 2.7 0 2.7z"
      fill="#F5E202"
    />
    <path
      d="M255.205 83.777c-2.9 1.9-5.9 5.5-6.9 9.4-.9 3.8.2 7.4 3.6 8.6 2.4.9 8-.2 12.2-3.1 4.2-2.9 7.2-6.9 7.7-10.5.4-3.5-.7-7.8-6.3-7.9-4.1 0-7.1 1.3-10.3 3.5z"
      stroke="#28362C"
      strokeWidth=".6"
      strokeMiterlimit="10"
    />
    <path
      d="M215.605 54.077s2.6.8 2.5 3.6c-.2 3-9.2 33.5-9.9 36.2-.7 2.8-1.7 6.9-5.6 6.4 1.6-4.8 13-46.2 13-46.2z"
      fill="#63796D"
    />
    <path
      d="M183.405 83.277c-.2 2.4 4.3 8.8 6.7 7 2.4-1.8-1.8-7.4-3.3-8.5-1.6-1.2-3.2-.2-3.4 1.5z"
      fill="#9E8080"
    />
    <path
      d="M185.005 77.576c-1.2 2.1 4.4 8.8 6.8 8.2 2.4-.6 2.7-2.9.9-4.8-1.8-1.8-5.7-6.8-7.7-3.4z"
      fill="#9E8080"
    />
    <path
      d="M186.805 71.977c-1.4 2.3 5.4 9.9 7.9 9.4 2.4-.6 2.8-2.9.9-4.8s-7.1-7.4-8.8-4.6z"
      fill="#9E8080"
    />
    <path
      d="M188.705 67.377c-1.3 1.9 4.7 8.8 7.2 9 2.3.3 2.9-2.8 1.1-4.7-1.8-1.9-6.3-7.3-8.3-4.3z"
      fill="#9E8080"
    />
    <path
      d="M217.305 58.377l-11.2 39c-.7 2.3-2.6 3.2-4.1 2.9l-15.3-4.5c-2-.6-3.4-2.2-2.8-4.3l11.3-39.6c.6-2 2.6-3.1 4.6-2.5l15.2 4.4c2 .6 2.9 2.5 2.3 4.6z"
      fill="#3C5749"
      fillOpacity=".86"
    />
    <path
      d="M212.505 54.577s-.6 1.7-2 1.3c-.8-.2-5-1.5-5.9-1.7-.9-.3-2.7-.7-2.9-1.2-.4-.7.2-1.2-.1-1.4-.2-.2-2.6-1-3.4-.6-.9.4-1.3 1.1-1.6 2.5-.4 1.4-9.3 32.6-9.8 34.4-.4 1.8-1 3.4-1 3.8 0 .6 0 1.8 1.4 2.4 1.4.6 13.9 4 14.8 4.3 1.2.4 2.7-.3 2.9-1.5.3-1.2 10.7-37.1 11-38.2.3-1 .5-2.4-1-3.2-1.4-.7-2.4-.9-2.4-.9z"
      fill="#fff"
    />
    <path
      d="M210.005 54.377c.2.1.1.3-.1.3s-5.4-1.6-5.6-1.7c-.2-.1-.2-.3.1-.3.1 0 5.1 1.6 5.6 1.7zM203.005 52.277c.1.1 0 .2-.1.3-.1.1-.3 0-.3-.2.1-.2.3-.2.4-.1z"
      fill="#28362C"
    />
    <path
      d="M191.705 74.777c-.2.6-.7 2.2-.9 2.9-.2.7-.1 1.7 1.1 2.1 4.9 1.5 8.9 2.6 14.1 4.1 1 .3 1.6-.5 1.8-1.1.3-.9.8-2.8.9-3.5.1-.9-.6-1.2-1.4-1.4-4.9-1.5-7.9-2.4-13.4-3.8-.7-.3-1.8-.5-2.2.7z"
      fill="#FF3008"
    />
    <path
      d="M199.105 64.577l8.7 2.6M196.205 66.177l13.1 3.9M195.505 68.477l13.2 4"
      stroke="#C7C6B7"
      strokeWidth=".3"
      strokeMiterlimit="10"
    />
    <path
      d="M187.305 95.977l11.3 3.4s3-6.8 7.8-7.7c.4-2.2.5-4 .7-7.1.1-3.6 1.9-6.3 4.2-5.8 1.8 3.2 1.6 16.7 1.6 16.7l-5.2 12-4.3 9.2-17.6-4.5 1.5-16.2z"
      fill="#9E8080"
    />
    <path
      d="M90.805 235.676s-18.3-18.2-26.4-29.2c-3.3-4.4-7.4-20.3-20-28-8.3-5.1-25.2-5.2-30 1.7 3.9 19.6 30 46.4 40.5 56.8 16.8-.5 33.3-2.2 35.9-1.3z"
      fill="#BEDFE9"
    />
    <path
      d="M82.005 73.577c3.5 4 1.2 15.2 1.2 22.9 0 12-7.7 36-14.7 49.9-5.1 10.3-35.5 41.5-35.5 41.5l-15 .8c-13.5-7.4 15.2-86.5 18.6-91 3.4-4.5 31.1-22.4 31.1-22.4l14.3-1.7zM124.805 77.477c5.9 1.5 18.3 7.9 23.8 13.7 6.8 10.4 18 34 22.9 49.8 3.9 12.7 13.4 51.8 12.9 62.2-2.2 1.7-10.6 5.4-22.7 6.9-2.6 1.2-21-23.7-27.2-37.8-4.7-10.8-24.1-46.6-21.5-64 2.5-17.5 11.8-30.8 11.8-30.8z"
      fill="#BEDFE9"
    />
    <path
      d="M132.105 80.877c-.9-.7-2-1.4-3.2-2-1.5-.6-2.9-1.1-4.1-1.4 0 0-9.2 13.3-11.9 30.7-2.7 17.4 16.7 53.2 21.5 64 2.4 5.5 6.7 12.7 11.2 19.3-1.7-38-6.3-105.1-13.5-110.6z"
      fill="#A9D7E0"
    />
    <path
      d="M81.505 73.477s38.2-2.1 50.5 7.4c10 7.7 15.1 134.2 13.9 136.4-1.2 2.2-97.6 3.6-101.1-1.4-7.8-11.2 6.9-108 11.7-118.4 8.3-17.9 25-24 25-24zM185.505 107.577s-12.9 26.8-17.1 39.7c.4 8.5-3.9 55.3-3.9 55.3s17.2 3 19.7.3c2.7-2.9 14.1-44 14.1-44l11.5-44.5c-2.9-1.1-24.3-6.8-24.3-6.8z"
      fill="#BEDFE9"
    />
    <path
      d="M171.005 139.577c-1 2.5-1.8 4.9-2.5 6.9.4 9-2.8 62.8-2.8 62.8s2-.2 4.9-.8c1.6-.4 3.1-.8 4.4-1.2.2-.1.4-.1.7-.2h.1c2.6-.9 5.4-2.1 8.2-3.7l.3-.3c.3-10-8.9-48.2-13.3-63.5z"
      fill="#A9D7E0"
    />
    <path
      d="M47.406 241.377l54.099.3h51.2l-9-35.7-95.9-9.4-.4 44.8z"
      fill="#4E6659"
    />
    <path
      d="M119.505 75.177s-11.7 9.7-12.2 28.7l10 1s2.8-18.7 13.3-26.3c-1.4-1.4-3.2-2.2-5.4-3.4-3-.6-5.7 0-5.7 0zM66.305 75.877s-6.7 5.3-9.6 24.8l10 1s2.7-19.8 13.1-27.4c-1.4-1.4-3.6-1.7-6.5-1.7-5.3.4-7 3.3-7 3.3z"
      fill="#FF4723"
    />
    <path
      d="M133.105 240.777s14-12.3 12.9-24.7"
      stroke="#28362C"
      strokeWidth=".5"
      strokeMiterlimit="10"
    />
    <path
      d="M47.805 196.577l-.5 18.5c.1.3-.1 8.9-.1 8.9s97.3-4.5 98.4-6.7c.1-.2.1-1.3.1-3l-2-8.2-95.9-9.5z"
      fill="#3C5749"
    />
    <path
      d="M114.605 74.977l-1.9-22.9s-17.3-17.3-20.5-16c-3.2 1.3-8.3 12.6-8.3 12.6l-5 26.2s1.5 3.9 3.2 5.1c5.6 3.9 18.8 1 18.8 1l13.7-6z"
      fill="#9E8080"
    />
    <path
      d="M86.106 13.577c-6.5 6-12.8 21.5-2.6 35.9 10.2 14.4 29.799 15.5 37.199 9.3 5.8-4.8-1.3-36.9-9.6-44.6-8.3-7.7-21.2-4.2-25-.6z"
      fill="#9E8080"
    />
    <path
      d="M104.105 41.577s1.1 18.6 8.7 22c7.6 3.4 12.6 1.2 13.5-1.7 1.4-4.2-.7-18.6-4.1-19-3.4-.4-5 6.7-11.1 5.3-2.4-.6-3.2-12-4.5-12-1.2-.1-2.5 5.4-2.5 5.4zM107.905 25.177s10.2 5 14.6.3 2.9-10.5-1.2-11.1c-4.1-.6-8.2 2-10.3-.2-2-2.2-13.5-3.6-15.2.2-1.6 3.8 3 13.5 12.1 10.8z"
      fill="#28362C"
    />
    <path
      d="M82.305 85.077c3 2.8 16.7.9 20.9-.3 5.3-1.5 10.4-4.2 10.4-4.2"
      stroke="#fff"
      strokeWidth=".5"
      strokeMiterlimit="10"
    />
    <path
      d="M104.005 22.177s8.5 6.8 16.2 2.3c5.4-3.1 2-9.5 1.5-11.3"
      stroke="#3C5749"
      strokeWidth=".528"
      strokeMiterlimit="10"
    />
    <path
      d="M171.405 139.376s5.7 20.5 7.8 34.7"
      stroke="#fff"
      strokeWidth=".5"
      strokeMiterlimit="10"
    />
    <path
      d="M130.305 186.277c7.5-1.4 14.6-11 14.6-11l1.9 5.3s.1 5.7-.3 6.5c-2.4 4.3-10 9-16.1 11-3.4 1.1-5-10.9-.1-11.8z"
      fill="#28362C"
    />
    <path
      d="M125.005 100.077c2.2.2 2.8 11.3 2.8 11.3s4.8 84.7 2.7 88.1c-3.2 5.3-20.5 14.2-23.9 15.2-2.3.7-10.4-95.9-10.8-100.2-.5-4.2 27.1-14.7 29.2-14.4z"
      fill="#FF4926"
    />
    <path
      d="M42.306 210.876c2.1 2.3 58.999 5.2 64.899 3.5 1.4-.4-4.3-96.8-4.3-96.8s-59.7-4-61.4-2.6c-1.7 1.4-2.3 92.6.8 95.9z"
      fill="#FF4723"
    />
    <path
      d="M106.405 214.577c.3 0 .6-.1.8-.2 1.4-.4-4.3-96.8-4.3-96.8s-2.7-.2-6.9-.4c1.4 16 8.1 94.1 10.4 97.4z"
      fill="#FF3008"
    />
    <path
      d="M125.905 99.777s4.5 13.9 3.6 16.1c-.9 2.1-22.3 14.8-23.8 13.7-1.1-.8-2-18.9-2-19.5 0-.6 22.2-10.3 22.2-10.3z"
      fill="#FF5534"
    />
    <path
      d="M38.605 128.376c.2 1.8 67.4 1.5 67.4 1.5l-1-17.9-63.4-.9s-3.3 13.7-3 17.3z"
      fill="#FF5534"
    />
    <path
      d="M125.905 99.776c2.2.601-14.5 9.001-21.5 12.501-3.1 1.5-63.4.499-62.8-1.201.3-.9 15-12.6 18.1-12.9 9.3-.7 57.4-.9 66.2 1.6z"
      fill="#FF5534"
    />
    <path
      d="M63.205 111.977s18.2.3 41.5.3c0 0 14.8-7.6 21.2-12.5M105.905 129.977s.3-8.1-1.1-17"
      stroke="#DA260D"
      strokeWidth=".663"
      strokeMiterlimit="10"
    />
    <path
      d="M59.505 154.977c.7 1.5.5 2.5 1.7 3.8 1.2 1.3 2 2 2.7 2 .8 0 5.5-.5 8.3-.4 2.8 0 5 0 5.3 1.3.2 1.3.2 2-1.8 2.3-2 .2-6.3-.1-7 .2-.8.2-3.5 0-2.3 1.2 1.2 1.2 4 4.5 4.8 4.4 1.3-.1 6.2-.1 8-.201 2.9-.199 5.5-5.1 5.3-7.5-.2-2.4-2.5-6.599-5.2-6.899-2.8-.3-10.8-.3-12.5-.4-1.7-.1-7.3.2-7.3.2z"
      fill="#fff"
    />
    <path
      d="M115.305 31.177s1.1 8.1 4.6 9.8c3.5 1.6 3.8-9.8 3-10.9-.8-1.1-6.5-1.9-7.6 1.1zM95.805 35.577l21.1-.9"
      stroke="#666"
      strokeWidth=".612"
      strokeMiterlimit="10"
    />
    <path
      d="M69.906 42.377c4.5 11.4 16.1 15.5 25.5 13.3 10.299-2.4 13.899-14.8 13.899-14.8s-2.7-9.9-.4-13.3c3.4-4.9 7.2-7.7 9.6-11.8 1.9-3.4-9.1-22.2-33.7-13.5-18.9 6.9-20.2 26.4-14.9 40.1z"
      fill="#E6E5D7"
    />
    <path
      d="M98.005 37.276c-2.1.7-3 5.7-.4 6.8 2.5 1 5.5.3 6-2.6.6-4-3.2-5-5.6-4.2zM102.605 3.477s-14.9-2.9-25.5 6.6c-8 7.2-8.1 18.2-6.6 25"
      stroke="#C7C6B7"
      strokeWidth=".5"
      strokeMiterlimit="10"
    />
    <path
      d="M203.305 56.676c.1.4-.1.6.1.9.2.3.3.5.4.6.1.1 1.2.2 1.7.4s1 .3 1 .6-.1.4-.5.4c-.4-.1-1.3-.4-1.5-.4-.2 0-.7-.2-.5.1.2.3.6 1.2.7 1.2.3.1 1.3.4 1.7.4.6.1 1.4-.7 1.6-1.2.1-.5-.1-1.5-.7-1.7-.6-.2-2.2-.7-2.6-.8-.2-.2-1.4-.5-1.4-.5z"
      fill="#FF3008"
    />
    <path
      d="M200.705 79.877c0-.1.1-.3.1-.4 0-.1.1-.3.1-.4 0-.2.1-.3.1-.5 0 .1.1.1.1.2 0 0 0 .1.1.1.1.1.1.2.2.3.1.1.1.1.1.2s.1.2.1.3c0 .1.1.2.1.3 0 0 0 .1.1.1 0 0 0 .1.1.1s.1.1.2.1h.1c0-.1 0-.1.1-.2 0-.1.1-.3.1-.4 0-.1.1-.2.1-.3 0-.1.1-.3.1-.5v-.1c0-.1.1-.2.1-.4v-.1c-.1 0-.1-.1-.2-.1h-.2s-.1 0-.1.1v.1c0 .1 0 .2-.1.2v.2c0 .1 0 .2-.1.3v.1c0 .1 0 .2-.1.3v.1c-.1-.1-.1-.2-.2-.3 0-.1-.1-.1-.1-.2-.1-.1-.1-.2-.2-.4 0-.1-.1-.2-.1-.3-.1-.1-.1-.2-.1-.4 0-.1-.1-.2-.2-.2h-.2c0 .1 0 .2-.1.2 0 .1-.1.3-.1.4 0 .1-.1.2-.1.3 0 .1-.1.3-.1.4 0 .2-.1.3-.1.5 0 .1 0 .1.1.1h.1c0 .2.1.2.2.2zM193.505 76.576c-.1.3-.1.5-.2.8v.1c0 .1 0 .2-.1.2v.2c.2 0 .3.1.5.1.1 0 .2.1.2.1h.5c.1 0 .1 0 .2-.1s.2-.1.3-.2c.1-.1.2-.2.2-.3.1-.1.1-.2.1-.4v-.2c0-.1 0-.3-.1-.4 0-.1-.1-.1-.1-.2v-.1c-.1-.1-.2-.1-.2-.2l-.1-.1c-.1 0-.3-.1-.4-.1h-.2c-.1 0-.2 0-.3-.1h-.1c0 .1-.1.2-.1.2 0 .4 0 .5-.1.7zm.6-.2c.1 0 .2.1.3.1.2.1.3.2.4.5v.2c0 .1 0 .2-.1.3 0 .1-.1.1-.1.2-.1.1-.2.1-.3.2h-.3c-.1 0-.2 0-.2-.1h-.1c.1-.5.2-.9.3-1.4h.1zM206.305 80.076c-.1 0-.1 0-.2-.1h-.1l-.1.1c-.1.1-.2.3-.3.4v-.2-.6s0-.1-.1-.1H205.205l-.1.1c-.1.1-.1.2-.2.3-.1.1-.1.2-.2.2v-.2-.4-.4c-.1 0-.2 0-.3-.1 0 0-.1 0 0 .1v1.3c0 .1 0 .1.1.1h.1c.1 0 .1 0 .2-.1.1-.2.2-.3.3-.5 0-.1.1-.1.1-.2v.8c0 .1 0 .1.1.2h.2s0-.1.1-.1c.1-.2.2-.3.3-.5.1-.1.2-.3.3-.4.1.5.1.4.1.3.1.1.1 0 0 0zM199.105 77.876H198.805c.1-.2.2-.7.3-.9-.1-.1-.2-.1-.3-.1-.1 0-.1 0-.1.1s-.1.5-.2.6c0 .1-.1.2-.1.3-.1.2-.1.4-.1.6 0 .2-.1.4-.1.6v.1h.2c.1 0 .1 0 .1-.1s.1-.2.1-.3c0-.1 0-.1.1-.2 0-.1.1-.2.1-.3 0 0 0-.1.1-.1h.4s.1 0 .1.1v.1c0 .1 0 .3-.1.4-.1.1-.1.3-.1.4v.1c.1 0 .1.1.2.1 0 0 .1 0 .1-.1s.1-.2.1-.3c0-.1.1-.3.1-.4 0-.1.1-.3 0-.5 0-.1 0-.2-.1-.2l-.1-.1c-.2.1-.3.1-.4.1zM195.205 78.177l.1.1c.1.1.3.2.4.2h.2c0 .1 0 .1.1.1h.2c0-.1.1-.1.1-.1.1-.2.1-.4.2-.6v-.2-.2-.2c0-.1-.1-.1-.2-.2s-.1-.1-.2-.1h-.4c-.1 0-.2 0-.3.1-.1 0-.1.1 0 .1l.1.1s.1.1.1 0c.1 0 .1 0 .2-.1.2 0 .3.1.3.2H195.505c-.1 0-.2 0-.2.1-.1.1-.2.2-.2.3.1.2.1.3.1.4zm.5-.3h.4c.1 0 .1 0 .1.1s0 .1-.1.1-.2.1-.3.1c-.1 0-.2-.1-.2-.2l.1-.1zM203.105 79.177c-.1 0-.3.1-.4.2-.1.1-.2.2-.2.3 0 0-.1.1 0 .2v.2c0 .1 0 .2.1.3.1.2.3.3.5.4h.3c.2 0 .4-.2.5-.3.1-.2.2-.4.1-.6 0-.1-.1-.3-.2-.4-.1-.1-.2-.2-.4-.2-.1-.1-.2-.1-.3-.1zm.3.3c.1 0 .2.1.2.2s.1.2.1.3c0 .2-.1.3-.3.4h-.2c-.2 0-.3-.1-.3-.2v-.3c0-.1.1-.2.2-.3h.1c.1-.1.1-.1.2-.1zM197.205 78.876h.2c.2 0 .3-.1.4-.3v-.3c0-.1-.1-.2-.2-.2s-.1-.1-.2-.1l-.1-.1.1-.1c.1 0 .2.1.2.1v.1h.1l.1-.1h.1c0-.1 0-.1-.1-.2l-.1-.1c-.2-.1-.4-.2-.6-.1-.1.1-.2.1-.2.3 0 .1 0 .2.1.3 0 .1.1.2.2.2s.1.1.1.2 0 .2-.1.2-.1 0-.2-.1l-.1-.1h-.1c-.1.1-.2.1-.3.2.1.1.2.3.4.3.2-.1.3-.1.3-.1z"
      fill="#fff"
    />
    <path
      d="M21.905 241.477h237.2"
      stroke="#3C5749"
      strokeWidth=".5"
      strokeMiterlimit="10"
    />
  </Svg>
)

export default StartDashing
